<script>
  // Additive scan input (spec §3): paste or upload as many lists as the count
  // took. Every add merges into the one deduped scan set.
  import { addScans, pasteLog, entries } from "./store";

  export let compact = false;

  let text = "";
  let lastAdd = null;

  function addPaste() {
    if (!text.trim()) return;
    lastAdd = addScans(text, "paste");
    text = "";
  }

  function addFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      lastAdd = addScans(String(reader.result), file.name);
    };
    reader.readAsText(file);
    e.target.value = "";
  }
</script>

<div>
  <textarea
    class="form-control font-monospace"
    rows={compact ? 4 : 8}
    placeholder="Paste scans — one barcode or SKU per line. Notes and tallies are tolerated."
    bind:value={text}
  />
  <div class="d-flex flex-wrap align-items-center gap-2 mt-2">
    <button class="btn btn-primary btn-sm" on:click={addPaste} disabled={!text.trim()}>
      <i class="fas fa-plus me-1" />Add to count
    </button>
    <label class="btn btn-outline-secondary btn-sm mb-0">
      <i class="fas fa-file-csv me-1" />Upload CSV
      <input type="file" accept=".csv,.txt" hidden on:change={addFile} />
    </label>
  </div>

  {#if lastAdd}
    <div class="small text-success mt-1">
      Added {lastAdd.added} new scans{lastAdd.dupes ? `, ${lastAdd.dupes} duplicates merged` : ""}.
    </div>
  {/if}

  {#if $pasteLog.length > 0}
    <div class="small text-muted mt-1">
      <strong>{$entries.length}</strong> scans in this count from {$pasteLog.length}
      {$pasteLog.length === 1 ? "list" : "lists"}:
      {#each $pasteLog as log, i}{i > 0 ? ", " : " "}{log.source} (+{log.added}){/each}
    </div>
  {/if}
</div>
